// 管理员相关API
import httpClient from '../http'
import { API_ENDPOINTS } from '../config'

export const adminApi = {
  // APP管理相关
  getApps: params => httpClient.get(API_ENDPOINTS.APP_MANAGEMENT.LIST, { params }),
  
  createApp: data => httpClient.post(API_ENDPOINTS.APP_MANAGEMENT.CREATE, data),
  
  updateApp: (id, data) => httpClient.put(`${API_ENDPOINTS.APP_MANAGEMENT.UPDATE}&id=${id}`, data),
  
  deleteApp: id => httpClient.delete(`${API_ENDPOINTS.APP_MANAGEMENT.DELETE}&id=${id}`),
  
  updateAppStatus: (id, data) => httpClient.put(`${API_ENDPOINTS.APP_MANAGEMENT.TOGGLE_STATUS}&id=${id}`, data),
  
  getAppUsers: (id, params = {}) => httpClient.get(`${API_ENDPOINTS.APP_MANAGEMENT.USERS}&app_id=${id}`, { params }),
  
  getAppDevices: (id, params = {}) => httpClient.get(`${API_ENDPOINTS.APP_MANAGEMENT.DEVICES}&app_id=${id}`, { params }),
  
  getAppStats: (id, params = {}) => httpClient.get(`${API_ENDPOINTS.APP_MANAGEMENT.STATS}&app_id=${id}`, { params }),
  // 管理员查看用户金币记录
  userCoinRecords: params => httpClient.get('/api/admin-user-coins.html?action=records', { params }),
  searchUserForCoins: params => httpClient.get('/api/admin-user-coins.html?action=users', { params }),
  searchAgentForCoins: params => httpClient.get('/api/admin-user-coins.html?action=agents', { params })
}
